import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'

export const Video = styled.video`
  max-width: 412px;

  ${Media.Phone`
    max-width: 300px;
  `}
`

export const Description = styled.div`
  ${Typography.sizes.Body};
  color: ${Colors.Neutral90};
  display: flex;
  align-items: center;
  gap: 4px;
`
